import moment from "moment";
const formatDate = (dateString: string, onlyDate?: boolean) => {
  return dateString
    ? getFormattedDate(
        dateString,
        onlyDate ? dateFormat.DMMMMYYYY : dateFormat.DateWithTimeStamp
      )
    : "-";
};

export default formatDate;

const getFormat = (dateEnum: dateFormat) => {
  switch (dateEnum) {
    case dateFormat.DOMMMMYYYY:
      return "Do MMMM YYYY";
    case dateFormat.DDMMMYYYY:
      return "DD MMM YYYY";
    case dateFormat.DDWithSlash:
      return "DD/MM/YYYY";
    case dateFormat.DMMMMYYYY:
      return "D MMMM YYYY";
    default:
      return "D MMMM YYYY, h:mm:ss A";
  }
};

export const getFormattedDate = (date: string, formatTyPe: dateFormat) => {
  if (!date) return "-";
  const formatType = getFormat(formatTyPe);

  const momentDate = moment.tz(date, "Asia/Singapore");
  // Check if the date is invalid or if it's the Unix epoch (1970-01-01 00:00:00)
  // This allows legitimate dates from 1970 like 1970-09-09 to pass through
  if (
    !momentDate.isValid() ||
    (momentDate.year() === 1970 &&
      momentDate.month() === 0 &&
      momentDate.date() === 1 &&
      momentDate.hour() === 0 &&
      momentDate.minute() === 0 &&
      momentDate.second() === 0)
  ) {
    return "-";
  }
  return momentDate.format(formatType);
};

export enum dateFormat {
  DateWithTimeStamp,
  DOMMMMYYYY,
  DDMMMYYYY,
  DDWithSlash,
  DMMMMYYYY,
}
